import React from "react";

export default function EmailInput(props) {
  return (
    <div className="input__outer">
      {props.label && (
        <label htmlFor={props.label.replace(/\s/g, "")} className="mb-1">
          {props.label}
          {props.isRequired ? <span className="!text-red-500"> *</span> : ""}
        </label>
      )}
      <div
        className={
          "input " + (props.error && props.value === "" ? "error" : "")
        }
      >
        <input
          onChange={props.onChange}
          value={props.value}
          type={props.type}
          placeholder={props.placeholder}
          autoFocus={props.autoFocus ? props.autoFocus : ""}
          className={props.className}
        />
        {props.icon && (
          <div className="input__icon" onClick={props.iconClickHandler}>
            {props.icon}
          </div>
        )}
      </div>
      {props.error && props.value === "" && (
        <div className="input__error">{props.errorText}</div>
      )}
    </div>
  );
}
